import { __assign, __rest } from "tslib";
import React from 'react';
import { FilterIcon } from 'components';
export var getSectionFormItem = function (_a) {
    var formType = _a.formType, inputProps = _a.inputProps, xs = _a.xs;
    return ({
        formType: formType || 'textField',
        inputProps: __assign({ hasEndCopyIcon: true }, inputProps),
        xs: xs
    });
};
export var getSectionForm = function (sectionFormParams, hasCustomerProfileFilter) {
    var header = sectionFormParams.header, item = sectionFormParams.item, prefix = sectionFormParams.prefix;
    return {
        header: header,
        items: Object.keys(item).map(function (key) {
            var _a = item[key], hasFilter = _a.hasFilter, inputProps = _a.inputProps, otherProps = __rest(_a, ["hasFilter", "inputProps"]);
            var _b = inputProps || {}, InputProps = _b.InputProps, otherInputProps = __rest(_b, ["InputProps"]);
            return getSectionFormItem(__assign(__assign({}, otherProps), { inputProps: __assign({ name: "".concat(prefix, ".").concat(key), variant: 'standard' }, __assign(__assign({}, otherInputProps), { InputProps: __assign(__assign({}, InputProps), (hasCustomerProfileFilter && hasFilter
                        ? {
                            endAdornment: React.createElement(FilterIcon, null)
                        }
                        : {})) })) }));
        })
    };
};
//# sourceMappingURL=getSectionForm.js.map